module.exports = __webpack_public_path__ + "img/collections.fe82ce2.webp";